import { useMutation, gql } from "@apollo/client"
import { JOB_FIELDS } from "./useQueryJobs"

const RUNADHOCPROCESS_MUTATION = gql`
  ${JOB_FIELDS}
  mutation RunAdhocProcess($id: ID!, $title: String!, $location: ID!) {
    runAdhocProcess(id: $id, title: $title, location: $location) {
      ...JobFields
    }
  }
`

const useMutationRunAdhocProcess = () => useMutation(RUNADHOCPROCESS_MUTATION)

export { useMutationRunAdhocProcess }
